import request from '@/util/request'
import store from '../store/store'

// 首页加载所有设备
export function load2 () {
  let token = store.getters.get_token
  return request({
    url: '/load2',
    method: 'get',
    params: { token: token }
  })
}
// 查看未绑定设备类型
export function getdevicetype (data) {
  let token = store.getters.get_token
  return request({
    url: '/getdevicetype',
    method: 'post',
    params: { token: token },
    data
  })
}
// 添加设备
export function adddevice (data) {
  let token = store.getters.get_token
  return request({
    url: '/adddevice',
    method: 'post',
    params: { token: token },
    data
  })
}
// 编辑主设备
export function updatedevice (data) {
  let token = store.getters.get_token
  return request({
    url: '/updatedevice',
    method: 'post',
    params: { token: token },
    data
  })
}
// 删除主设备
export function deldevice (data) {
  let token = store.getters.get_token
  return request({
    url: '/deldevice',
    method: 'post',
    params: { token: token },
    data
  })
}
// 设置 902 设备呼叫号码
export function set902device (data) {
  let token = store.getters.get_token
  return request({
    url: '/set902device',
    method: 'post',
    params: { token: token },
    data
  })
}
// 获取所有设备
export function loadAllDevice () {
  let token = store.getters.get_token
  return request({
    url: '/load2',
    method: 'get',
    params: { token: token }
  })
}
// 获取虚拟房间
export function queryvirtualroom () {
  let token = store.getters.get_token
  return request({
    url: '/queryvirtualroom',
    method: 'post',
    params: { token: token }
  })
}
// 获取 虚拟房间及设备
export function queryvirtualroomdevice () {
  let token = store.getters.get_token
  return request({
    url: '/queryvirtualroomdevice',
    method: 'post',
    params: { token: token }
  })
}
// 添加房间（场景）   当值为0时，自动创建家庭
export function addvirtualroom (data) {
  let token = store.getters.get_token
  return request({
    url: '/addvirtualroom',
    method: 'post',
    params: { token: token },
    data
  })
}
// 编辑房间名称（场景）
export function editvirtualroom (data) {
  let token = store.getters.get_token
  return request({
    url: '/editvirtualroom',
    method: 'post',
    params: { token: token },
    data
  })
}
// 删除房间（场景）
export function delvirtualroom (data) {
  let token = store.getters.get_token
  return request({
    url: '/delvirtualroom',
    method: 'post',
    params: { token: token },
    data
  })
}
// 先删除再添加；
// 添加房间设备（场景）
export function addroomdevice (data) {
  let token = store.getters.get_token
  return request({
    url: '/addroomdevice',
    method: 'post',
    params: { token: token },
    data
  })
}
// 删除房间设备（场景）
export function delroomdevice (data) {
  let token = store.getters.get_token
  return request({
    url: '/delroomdevice',
    method: 'post',
    params: { token: token },
    data
  })
}
// 分享家庭
export function sharevirtualroom (data) {
  let token = store.getters.get_token
  return request({
    url: '/sharevirtualroom',
    method: 'post',
    params: { token: token },
    data
  })
}
// 退出/取消家庭分享
export function deletesharevirtualroom (data) {
  let token = store.getters.get_token
  return request({
    url: '/deletesharevirtualroom',
    method: 'post',
    params: { token: token },
    data
  })
}
// 查询家庭分享情况
export function queryshareroomphone (data) {
  let token = store.getters.get_token
  return request({
    url: '/queryshareroomphone',
    method: 'post',
    params: { token: token },
    data
  })
}
// NB门磁布撤防 0 撤防，1布防  2开启开门，3开启关门
export function setdevicenotify (data) {
  let token = store.getters.get_token
  return request({
    url: '/setdevicenotify',
    method: 'post',
    params: { token: token },
    data
  })
}
// 查询设备历史记录
export function querydevicelog (data) {
  let token = store.getters.get_token
  return request({
    url: '/querydevicelog',
    method: 'post',
    params: { token: token },
    data
  })
}
// 历史记录
export function queryhisalarm (data) {
  let token = store.getters.get_token
  return request({
    url: '/queryhisalarm',
    method: 'post',
    params: { token: token },
    data
  })
}
// 设备通知方式
export function setdevicenotifytype (data) {
  let token = store.getters.get_token
  return request({
    url: '/setdevicenotifytype',
    method: 'post',
    params: { token: token },
    data
  })
}
// 事件列表
export function queryevent (data) {
  let token = store.getters.get_token
  return request({
    url: '/queryevent',
    method: 'post',
    params: { token: token },
    data
  })
}
// rtc 视频
export function calldeicevideo (data) {
  let token = store.getters.get_token
  return request({
    url: '/calldeicevideo',
    method: 'post',
    params: { token: token },
    data
  })
}
// 获取未处理的警报信息
export function queryunhandlealarm (data) {
  let token = store.getters.get_token
  return request({
    url: '/queryunhandlealarm',
    method: 'post',
    params: { token: token },
    data
  })
}
// 批量处理警报信息
export function handleallalarm (data) {
  let token = store.getters.get_token
  return request({
    url: '/handleallalarm',
    method: 'post',
    params: { token: token },
    data
  })
}
// 设置活动监测
export function setdevice (data) {
  let token = store.getters.get_token
  return request({
    url: '/setdevice',
    method: 'post',
    params: { token: token },
    data
  })
}
// 901设置设备发生指令
export function sendcommandmessage (data) {
  let token = store.getters.get_token
  return request({
    url: '/sendcommandmessage',
    method: 'post',
    params: { token: token },
    data
  })
}
// 获取录音列表
export function querydevicerecord (data) {
  let token = store.getters.get_token
  return request({
    url: '/querydevicerecord',
    method: 'post',
    params: { token: token },
    data
  })
}
// 获取语音通知信息列表
export function querydevicevoicemessage (data) {
  let token = store.getters.get_token
  return request({
    url: '/querydevicevoicemessage',
    method: 'post',
    params: { token: token },
    data
  })
}
// w23 901 历史轨迹
export function querydevicelocationhistory (data) {
  let token = store.getters.get_token
  return request({
    url: '/querydevicelocationhistory',
    method: 'post',
    params: { token: token },
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/device.js